<script>
export default {
	name: 'AqKpi',
	props: {
		label: {
			type: String,
			required: true,
		},
		value: {
			type: [String, Number],
			default: '—',
		},
		unit: {
			type: String,
			default: '',
		},
		hint: {
			type: String,
			default: '',
		},
		tone: {
			type: String,
			default: 'neutral',
		},
		progress: {
			type: Number,
			default: null,
		},
	},
	computed: {
		barWidth() {
			return `${Math.max(0, Math.min(100, this.progress || 0))}%`
		},
	},
}
</script>

<template>
	<div class="aq-kpi" :class="`aq-kpi--${tone}`">
		<span class="aq-kpi__label">{{ label }}</span>
		<span class="aq-kpi__value">
			{{ value }}<small v-if="unit" class="aq-kpi__unit">{{ unit }}</small>
		</span>
		<span v-if="progress !== null" class="aq-kpi__bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
			<span :style="{ width: barWidth }"></span>
		</span>
		<span v-if="hint" class="aq-kpi__hint">{{ hint }}</span>
	</div>
</template>

<style scoped>
.aq-kpi {
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 18px 20px;
	border: 1px solid var(--aq-border);
	border-radius: var(--aq-radius);
	background: var(--aq-surface);
	box-shadow: var(--aq-shadow);
}
.aq-kpi__label {
	font-size: 13px;
	font-weight: 500;
	color: var(--aq-muted);
}
.aq-kpi__value {
	font-size: 28px;
	font-weight: 700;
	line-height: 1.15;
	color: var(--aq-ink);
}
.aq-kpi__unit {
	margin-left: 4px;
	font-size: 14px;
	font-weight: 500;
	color: var(--aq-muted);
}
.aq-kpi__hint {
	font-size: 13px;
	color: var(--aq-muted);
}
.aq-kpi__bar {
	height: 6px;
	border-radius: 999px;
	background: #edf2f8;
	overflow: hidden;
}
.aq-kpi__bar span {
	display: block;
	height: 100%;
	border-radius: inherit;
	background: var(--aq-primary);
	transition: width 0.4s var(--aq-ease);
}
.aq-kpi--success .aq-kpi__value,
.aq-kpi--success .aq-kpi__hint {
	color: var(--aq-success);
}
.aq-kpi--success .aq-kpi__bar span {
	background: var(--aq-success);
}
.aq-kpi--warning .aq-kpi__value {
	color: var(--aq-warning);
}
.aq-kpi--warning .aq-kpi__bar span {
	background: #e39a1b;
}
.aq-kpi--danger .aq-kpi__value {
	color: var(--aq-danger);
}
.aq-kpi--danger .aq-kpi__bar span {
	background: var(--aq-danger);
}
</style>
